import { render, staticRenderFns } from "./ManageReports.vue?vue&type=template&id=8e74b542&"
import script from "./ManageReports.vue?vue&type=script&lang=js&"
export * from "./ManageReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports